jQuery( '.menu-toggle > a' ).click(function() { 
	
	if( jQuery( this ).data( 'action' ) == 'off-canvas' ) {
		
		jQuery( '.off-canvas-menu' ).addClass( 'active' );
		jQuery( '.menu-toggle' ).addClass( 'open' );
		jQuery(window).trigger('resize');
		
	}
	
	if( jQuery( this ).data( 'action' ) == 'off-canvas-close' ) {
		
		jQuery( '.off-canvas-menu' ).removeClass( 'active' );
		jQuery( '.menu-toggle' ).removeClass( 'open' );
		jQuery(window).trigger('resize');
		
	}

	
});


jQuery(document).ready(function() {
	
	var language = jQuery( '#page_language' ).val();
	
	if( language == 'espanol' ) {
		
		jQuery('.sd-title').text( 'Compartir:' );
		jQuery('.share-print span').text( 'Imprimir' );
		
	}
	
});